import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/** Reads the backend's already-aggregated Dashboard View Models (ADR-034). */
export const dashboardService = {
  async getSummary(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.dashboard.summary);
    return response.data;
  },
  async getSystem(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.dashboard.system);
    return response.data;
  },
  async getTrading(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.dashboard.trading);
    return response.data;
  },
  async getPortfolio(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.dashboard.portfolio);
    return response.data;
  },
};
